import React from "react";
import "./infobox.css";
const InfoBox = (props) => {
  return (
    <div
      className="infobox-main"
      onClick={() => {
        window.open(props.link.link || props.link[0], "_blank");
      }}
    >
      <div className="infobox">
        <img src={props.image} alt="No image Found" />
      </div>
      <div className="title">{props.title}</div>
      {props.designation && (
        <div className="designation">{props.designation}</div>
      )}
      {props.description && (
        <div className="description">{props.description}</div>
      )}
      {!props.socialMedia && (
        <div className="link">
          <a href={props.link.link}>
            {" "}
            <span className="link-title">
              {" "}
              <img src="https://res.cloudinary.com/urbanclap/image/upload/images-stage/supply/test-upload-use-case/1625646589936-e0b16b.svg" />{" "}
              {props.link.title}
            </span>{" "}
          </a>
        </div>
      )}
      {props.socialMedia && (
        <div className="social-media">
          <a href={props.link[0]} className="linkedin">
            <i className="fab fa fa-linkedin text-center"></i>
          </a>
          {props.link.length > 1 ? (
            <a href={props.link[1]} className="twitter">
              <i className="fab fa fa-twitter"></i>
            </a>
          ) : (
            <div />
          )}
        </div>
      )}
    </div>
  );
};

export default InfoBox;
